import { Component, Input, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-inventory-availability-dialog',
  templateUrl: './inventory-availability-dialog.component.html',
  styleUrls: ['./inventory-availability-dialog.component.scss'],
})
export class InventoryAvailabilityDialogComponent implements OnInit {
  product: any
  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.product = data.product
    })
  }
  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.INVENTORY_AVAILABILITY,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
